<template>
    <v-card class="mx-auto">
      <v-subheader>Last Added Jumps</v-subheader>
      <v-data-table :headers="headers" :items="recentJumps" :items-per-page="30">

        <template v-slot:item.startTime="{ item }">
          <span>{{ new Date(item.startTime).toLocaleString("en-AU", {
            timeZone: "UTC", weekday: 'short', year: 'numeric',
            month: 'short', day: 'numeric'
          }) }}</span>
        </template>

        <template v-slot:item.created="{ item }">
          <span>{{ new Date(item.created).toLocaleString("en-AU", {
            timeZone: "UTC", weekday: 'short', year: 'numeric',
            month: 'short', day: 'numeric'
          }) }}</span>
        </template>
  
        <template v-slot:item.actions="{ item }">
  

          <v-btn icon  small class="success white--text ma-2"
          @click="reschedule(item)">

          <v-icon center>mdi-update</v-icon>
        </v-btn>
        </template>
  
      </v-data-table>
  
  
    </v-card>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  
  export default {
  
    data: () => ({
  
      headers: [
        { text: '', align: 'start', value: '', },
        { text: 'Created', align: 'start', sortable: true, value: 'created', },
        { text: 'Jumper', align: 'start', sortable: true, value: 'fullName', },
        { text: 'Pckg', align: 'start', sortable: true, value: 'code', },
        { text: 'Jump Date', align: 'start', sortable: true, value: 'startTime', },
        // { text: 'Addons', align: 'start', sortable: true, value: 'billItems', },
        { text: '', value: 'actions', sortable: false },
      ],
  
      openExpand: true
  
    }),
  
    mounted() {
      this.$store.dispatch('getRecentlyAddedJumps')
      
    },
  
  
    computed: {
  
        ...mapState(['recentJumps'])
  
  
    },
  

  
    methods: {
        reschedule(item) {


      const index = this.recentJumps.indexOf(item)


      confirm('Are you sure you want to Reschedule for today?') &&
        axios.put('/api/jumps/reschedule/' + item.id)
          .then(response => {

            this.recentJumps.splice(index, 1)
            this.$store.dispatch('fetchData')
          })
          .catch(err => {
            alert(err)
          })

      },
  
    }
  
  }
  </script>